import { useState } from "react";
import {
  getGuestListing,
  updateGuestListing,
  deleteGuestListing,
} from "../api/guestListing";

export function useGuestListing() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGuestListing = async (token) => {
    setLoading(true);
    setError(null);
    try {
      return await getGuestListing(token);
    } catch (err) {
      setError(err.message || "Failed to fetch guest listing");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const update = async (token, data) => {
    setLoading(true);
    setError(null);
    try {
      return await updateGuestListing(token, data);
    } catch (err) {
      setError(err.message || "Failed to update guest listing");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const remove = async (token) => {
    setLoading(true);
    setError(null);
    try {
      return await deleteGuestListing(token);
    } catch (err) {
      setError(err.message || "Failed to delete guest listing");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    getGuestListing: fetchGuestListing,
    updateGuestListing: update,
    deleteGuestListing: remove,
    loading,
    error,
  };
}
